import { Icon } from "@dmm-com/rocket-web-ui-library";
import * as Styled from "./style";
import { DMM_SERVICE_MENU } from "~/components/blocks/layout/global-navi/const/dmm-service-menu";
import { MenuNameWithNewTag } from "~/components/blocks/layout/global-navi/mobile/left/dmm-service/menu-name-with-new-tag";
import { sendTrackingClickCommon } from "~/lib/tracking/events";

type AccordionContentProps = {
  name: string;
  href: string;
  src: string;
  parentName: string;
  viaViewRank: number;
  viaTargetId: string;
  isNew: boolean;
};

export const AccordionContent = ({
  href,
  name,
  parentName,
  src,
  viaViewRank,
  viaTargetId,
  isNew,
}: AccordionContentProps) => {
  const columnNum =
    parentName === DMM_SERVICE_MENU.OTHER_SERVICE || parentName === DMM_SERVICE_MENU.FOR_BUSINESS ? 1 : 2;
  return (
    <Styled.LIItem columnNum={columnNum}>
      <Styled.AnchorItem
        href={href}
        onClick={() => sendTrackingClickCommon({ clickEventName: "dmmtv_navigation", viaTargetId, viaViewRank })}
        aria-label={`${name}へのリンク`}
      >
        <Styled.DivTextWrapper>
          {parentName === DMM_SERVICE_MENU.OTHER_SERVICE && (
            <Styled.LazyImage width="30px" height="30px" alt="name" src={src} />
          )}
          <MenuNameWithNewTag menuName={name} isNew={isNew} isHeading={false} />
        </Styled.DivTextWrapper>
        <Icon name="arrowRight" size="M" color="GRAY500" />
      </Styled.AnchorItem>
    </Styled.LIItem>
  );
};
